module.exports = __webpack_public_path__ + "static/media/Visa-Logo-2005.cd8e0284.jpg";